import styled from "styled-components";

export const PageHeader = styled.div`
  margin-bottom: 24px;
  h1 { font-size: 24px; font-weight: 600; color: #014c75; margin: 0 0 8px 0; }
  p { color: #666; margin: 0; font-size: 14px; }
`;

export const SubmittedProfilesWrapper = styled.div`
  min-height: 100vh;

  .ant-table {
    background: white;
    border-radius: 8px;
  }
`;
